<template>
  <scout-form
    :is-modified="!!value.length"
    label="資格"
  >
    <div class="boss-layout boss-layout-start boss-layout-gap-large">
      <label
        v-for="(option, i) in options"
        :key="i"
        :data-test="`label-${i}`"
        class="pega-input"
      >
        <input
          :checked="selectedOption === option.key"
          :value="option.key"
          :data-test="`radio-${i}`"
          class="boss-input-checkbox"
          type="radio"
          @change="$emit('update:selectedOption', $event.target.value)"
        >{{ option.label }}
      </label>
    </div>
    <select-modal-button
      v-if="licensesMaster.length > 0"
      :master-data="licensesMaster"
      :selected-items="value.map(n => { return { id: n, experience: '' } })"
      title="資格"
      suffix="licenses"
      data-test="modal"
      @update-modal-checked-ids="value => $emit('input', value.map(o => o.id))"
    />
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import SelectModalButton from '@/components/organisms/SelectModalButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutForm,
    SelectModalButton
  },
  props: {
    selectedOption: {
      default: 'and',
      type: String
    },
    value: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      options: [
        { key: 'and', label: 'すべてを含む' },
        { key: 'or', label: 'いずれかを含む' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'licensesMaster'
    ])
  }
}
</script>
